module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "hayman.93db9b05.svg";